/**
 * Strips any absolute origin from a booking link so the browser uses the
 * current host (e.g. localhost:3000 in dev, millionspaces.com in prod).
 */
export const toRelativeBookingPath = (value) => {
  if (!value || typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  if (!/^https?:\/\//i.test(trimmed)) {
    return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  }

  try {
    const { pathname, search } = new URL(trimmed);
    return `${pathname}${search}`;
  } catch {
    return null;
  }
};

/**
 * Prefer API bookingUrl (normalised to a path); otherwise use client-built path.
 */
export const resolveSpaceCardBookingUrl = (space, fallback) => {
  const fromApi = toRelativeBookingPath(space?.bookingUrl);
  if (fromApi) return fromApi;
  return typeof fallback === 'function' ? fallback() : null;
};
